module.exports = __webpack_public_path__ + "img/ciu-logo.7a9ada95.svg";